import React from "react";
import NumberFlow, {continuous} from "@number-flow/react";
import {ArrowRightIcon} from "@phosphor-icons/react";
import {useData} from "context/data.context";
import {formatCurrency, formatPercent, formatCurrencyCompact} from "utilities/global.functions";

const ForecastCard = () => {
  const {networthCurrent, networthProjected} = useData();

  const projection = networthProjected.total ?? 0;
  const change = networthCurrent.total ? projection - networthCurrent.total : 0;
  const percent = change ? (change / networthCurrent.total) * 100 : 0;
  const currentYear = new Date().getFullYear();
  const futureYear = networthProjected.years ? currentYear + networthProjected.years : "";

  return (
    <>
   

      <div className="flex row around ">
        <div className="flex col xxlarge-gap ">
          <p className="large l4">Today</p>
          <p className="number xxlarge">{formatCurrencyCompact(networthCurrent.total)}</p>
        </div>

        <div className="flex end l4">
          <ArrowRightIcon size={28} weight="regular" />
        </div>

        <div className="flex col xxlarge-gap  end">
          <p className="large l4"> In {networthProjected.years} years </p>
          <p className="number xxlarge">{formatCurrencyCompact(projection,1)}</p>
        </div>
      </div>
    </>
  );
};

export default ForecastCard;
